<template>
  <div class="container-fluid p-0">
    <div v-if="isLoading">
      <Preloader/>
    </div>
    <div v-else>
      <h4 class="w-100 text-center" v-if="deviceReports.length === 0">در حال حاضر هیچ برنامه بازدید یا سرویسی ندارید</h4>
      <table class="table table-striped" v-else>
        <thead>
        <tr>
          <!--<th scope="col" class="text-center">عملیات</th>-->
          <!--<th scope="col" class="text-center">ردیف</th>-->
          <th scope="col" class="text-center">دستگاه</th>
          <th scope="col" class="text-center">برنامه</th>
          <!--<th scope="col" class="text-center">نوع چک لیست</th>-->
          <!--<th scope="col" class="text-center">گزارش</th>-->
          <!--<th scope="col" class="text-center">عملیات</th>-->

        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in deviceReports">

          <!--<th scope="row" class="text-center">{{item.id}}</th>-->
          <td class="text-center clickable" @click="gotoDevice(item)">{{item.companyName}}</td>
          <td class="text-center clickable" @click="gotoDevice(item)">{{item.checkListCount}} برنامه انجام نشده</td>
          <!--<td class="text-center">{{item.devicePMPlanning.pmCheckList.enPMListTypeTitle}}</td>-->
          <!--<input type="checkbox" v-model="item." />-->

          <!--<i class="clickable fa fa-print px-3" @click="saveReport(item)" ></i>-->
          <!--<td class="text-center">-->
          <!--<i class="clickable fa fa-id-card-o px-3" ></i>-->
          <!--<i class="clickable fa fa-print px-3" ></i>-->
          <!--</td>-->
          <!--<td class="text-center">-->
          <!--<i class="clickable fa fa-file-archive-o" @click="attachClicked(item)"></i>-->
          <!--</td>-->
          <!--<th scope="row" class="text-center">-->
          <!--<i class="clickable fa fa-check-square-o" @click="onGetCheckListClicked(item)"></i>-->
          <!--<i class="clickable fa fa-print px-3" @click="onPrintChecklistClicked(item)"></i>-->
          <!--</th>-->
          <!--<th scope="row" class="text-center">-->
          <!--<i class="clickable fa fa-calendar-check-o" @click="onReportClicked(item)"></i>-->
          <!--</th>-->
        </tr>
        </tbody>
      </table>

      <!--<div class="col-12" v-if="showPagination">-->
      <!--<b-pagination size="md" v-model="pageIndex" :total-rows="rows" :per-page="pageSize" align="center"-->
      <!--@input="nextPage(pageIndex)"/>-->
      <!--</div>-->

      <!--  <div class="col-12">
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            @input="onWorksPaginationChange"
            :per-page="pagination.pageSize"
          ></b-pagination>
        </div>-->
    </div>
    <!-------------------------------------------------------------------------------->
    <!------------ SHENASNAMEH  MODALS -------------------------------------------------------------------->


  </div>
</template>

<script>

  import VsSelect from "../../_framework/VsSelect";
  import BaseService from "../../_framework/api/BaseService.js";
  import Moment from "moment-jalali";
  import Vue from "vue";
  import Products from "../Products.vue";
  import * as $ from 'jquery';
  import checkAccess from "../../checkAccess";
  import CreateWork from "../CreateWork";
  import Utils from "../../_framework/utils/Utils";
  import VueHtmlToPaper from 'vue-html-to-paper';
  import DatePicker from "../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import Constants from "../../Constants";
  import BdInput from "../../components/BDInput";

  export default {
    name: "check-services",
    props: {},
    components: {
      BdInput,
      CreateWork,
      VsSelect,
      Products,
      datePicker: DatePicker,
    },
    data: function () {
      return {

        isLoading: false,
        deviceReports: [],
        enPMListTypes: [],
      }
    },
    mounted() {
      const printoptions = {
        name: '_blank',
        specs: [
          'fullscreen=yes',
          'titlebar=yes',
          'scrollbars=yes',

        ],
        styles: [
          './css/bootstrap4.min.css',
          './css/kidlat.css',
          './css/print-style.css',

        ],
        timeout: 10,
        autoClose: false,
        windowTitle: "شرکت آبان توسعه / پرینت رسید انبار"

      };
      Vue.use(VueHtmlToPaper, printoptions);
      new BaseService('PManagment', '/RefreshDevicePMReport').create().then((response) => {

      }).catch((error) => {
        console.log(error)
      });
      // this.getType();
      this.getDeviceReports();

      // this.getType();
    },
    methods: {

      getDeviceReports() {
        new BaseService('PManagment', '/GetServiceDevicePMReport/false').getList().then((response) => {
          this.deviceReports = response.data;

        }).catch((error) => {
          console.log(error)
        });
      },


      gotoDevice(item) {
        console.log(item)
        this.$router.push({
          name: "بازدیدهای دستگاه",
          params: {
            companyId : item.companyId
          }
        });
      },


    },

    computed: {
      myStylestx1() {
        return {
          height: `${this.tx1Height}px`,
          position: 'relative'
        }
      }
    }
  };

</script>

<style scoped>
  .table th, .table td {
    padding: 0.5rem !important;
  }
</style>
